"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSponsoredByProperty = exports.sponsoredByPropertyDefinition = void 0;
exports.sponsoredByPropertyDefinition = {
    view: {
        label: 'Sponsored by',
        hint: 'If this content creation is sponsored by a partner, link their profile here.',
    },
    constraints: [
        {
            name: 'stencils',
            argument: ['partner-profile'],
        },
    ],
    type: 'asset',
    multiple: true,
    name: 'sponsored-by',
};
const isSponsoredByProperty = (prop) => {
    return prop.name === exports.sponsoredByPropertyDefinition.name;
};
exports.isSponsoredByProperty = isSponsoredByProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3BvbnNvcmVkLWJ5LnByb3BlcnR5LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3Byb3BlcnRpZXMvc3BvbnNvcmVkLWJ5LnByb3BlcnR5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVhLFFBQUEsNkJBQTZCLEdBQUc7SUFDM0MsSUFBSSxFQUFFO1FBQ0osS0FBSyxFQUFFLGNBQWM7UUFDckIsSUFBSSxFQUFFLDhFQUE4RTtLQUNyRjtJQUNELFdBQVcsRUFBRTtRQUNYO1lBQ0UsSUFBSSxFQUFFLFVBQVU7WUFDaEIsUUFBUSxFQUFFLENBQUMsaUJBQWlCLENBQUM7U0FDOUI7S0FDRjtJQUNELElBQUksRUFBRSxPQUFPO0lBQ2IsUUFBUSxFQUFFLElBQUk7SUFDZCxJQUFJLEVBQUUsY0FBYztDQUNXLENBQUE7QUFJMUIsTUFBTSxxQkFBcUIsR0FBRyxDQUFDLElBQWtCLEVBQStCLEVBQUU7SUFDdkYsT0FBTyxJQUFJLENBQUMsSUFBSSxLQUFLLHFDQUE2QixDQUFDLElBQUksQ0FBQTtBQUN6RCxDQUFDLENBQUE7QUFGWSxRQUFBLHFCQUFxQix5QkFFakMifQ==